import styled, { ThemedStyledProps } from 'styled-components';
import { compose, fontSize, Theme, variant } from 'styled-system';

import {
  BORDER,
  COMMON,
  get,
  LAYOUT,
  SystemCommonProps,
  SystemLayoutProps
} from '../theme/constants';
import sx, { SxProp } from '../theme/utils/sx';

const composeSystem = compose(COMMON, LAYOUT, BORDER, fontSize);

export interface StyledNotificationProps
  extends SxProp,
    SystemCommonProps,
    SystemLayoutProps {
  variant: 'error' | 'warning' | 'success' | 'info';
}

const variants = (props: ThemedStyledProps<StyledNotificationProps, Theme>) => {
  return variant({
    variants: {
      info: {
        backgroundColor: get('colors.blue.5'),
        [StyledNotificationIcon]: {
          color: get('colors.blue.60')
        }
      },
      error: {
        backgroundColor: get('colors.red.5'),
        [StyledNotificationIcon]: {
          color: get('colors.red.60')
        },
        [StyledNotificationText]: {
          color: get('colors.red.70')
        }
      },
      warning: {
        backgroundColor: get('colors.yellow.5'),
        [StyledNotificationIcon]: {
          color: get('colors.yellow.30')
        },
        [StyledNotificationText]: {
          color: get('colors.yellow.70')
        }
      },
      success: {
        backgroundColor: get('colors.green.5'),
        [StyledNotificationIcon]: {
          color: get('colors.green.50')
        },
        [StyledNotificationText]: {
          color: get('colors.green.70')
        }
      }
    }
  });
};

export const StyledNotificationContainer = styled.div<StyledNotificationProps>`
  display: flex;
  align-items: center;
  border-radius: 8px;

  ${composeSystem}
  ${variants}
  ${sx}
`;

StyledNotificationContainer.defaultProps = {
  px: '18px',
  py: '14px'
};

export const StyledNotificationIcon = styled.span`
  width: 20px;
  height: 20px;
  font-size: 20px;
  align-self: flex-start;
`;

export const StyledNotificationText = styled.span`
  font-size: 0.75rem;
  margin-left: 10px;
  line-height: 16px;
`;
